export type ApiResponseStatus = 'success' | 'fail';

export interface CustomApiResponse<T = any> {
  status: ApiResponseStatus;
  message: string;
  code: number;
  data: T | null;
}

export function createApiResponse<T>(
  status: ApiResponseStatus,
  message: string,
  code: number,
  data: T | null = null
): CustomApiResponse<T> {
  return {
    status,
    message,
    code,
    data,
  };
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

/**
 * Defines the structure for paginated API responses.
 */
export interface PaginatedApiResponse<T> {
  data: T[];
  meta: PaginationMeta;
}


export type Severity = "success" | "info" | "warning" | "error";

export function extractErrorMessage(err: any): { message: string; code?: number } {
  // Axios-style
  const msg =
    err?.response?.data?.message ??
    err?.data?.message ??
    err?.message ??
    "Something went wrong.";
  const code =
    err?.response?.status ?? err?.response?.data?.code ?? err?.data?.code ?? err?.code;
  return { message: msg, code };
}
